'use client'
import Image from 'next/image'
import LinkComponent from '@components/LinkComponent'
import CurrencySymbol from '@components/CurrencySymbol'

// ─── Icons ────────────────────────────────────────────────────────────────────
const icons = {
  none: null,
  bed:      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 9V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v5"/><path d="M2 20v-5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v5"/><path d="M2 20h20"/><path d="M2 9h20"/><rect x="6" y="9" width="4" height="5"/><rect x="14" y="9" width="4" height="5"/></svg>,
  bath:     <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 6 6.5 3.5a1.5 1.5 0 0 0-1-.5C4.683 3 4 3.683 4 4.5V17a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5"/><line x1="10" y1="5" x2="8" y2="7"/><line x1="2" y1="12" x2="22" y2="12"/><line x1="7" y1="19" x2="7" y2="21"/><line x1="17" y1="19" x2="17" y2="21"/></svg>,
  area:     <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18"/><path d="M9 21V9"/></svg>,
  land:     <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 20h18"/><path d="m7 20-4-8"/><path d="m17 20 4-8"/><path d="m9 12 3-8 3 8"/><path d="M9 12h6"/></svg>,
  location: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>,
  price:    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
  building: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01"/><path d="M16 6h.01"/><path d="M12 6h.01"/><path d="M12 10h.01"/><path d="M12 14h.01"/><path d="M16 10h.01"/><path d="M16 14h.01"/><path d="M8 10h.01"/><path d="M8 14h.01"/></svg>,
  tag:      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"/><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"/></svg>,
  star:     <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>,
  ruler:    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z"/><path d="m14.5 12.5 2-2"/><path d="m11.5 9.5 2-2"/><path d="m8.5 6.5 2-2"/><path d="m17.5 15.5 2-2"/></svg>,
  transit:  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="3" width="16" height="16" rx="2"/><path d="M4 11h16"/><path d="M12 3v8"/><path d="M8 19l-2 3"/><path d="M18 22l-2-3"/><path d="M8 15h0"/><path d="M16 15h0"/></svg>,
  mountain: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m8 3 4 8 5-5 5 15H2L8 3z"/></svg>,
  waves:    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/><path d="M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/><path d="M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/></svg>,
  paw:      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="4" r="2"/><circle cx="18" cy="8" r="2"/><circle cx="4" cy="8" r="2"/><path d="M9.3 14a5 5 0 0 0-2.5 4.4V21h8.4v-2.6a5 5 0 0 0-2.5-4.4 3.7 3.7 0 0 0-3.4 0z"/><circle cx="18" cy="14" r="2"/></svg>,
  video:    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m22 8-6 4 6 4V8z"/><rect x="2" y="6" width="14" height="12" rx="2"/></svg>,
  cube:     <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>,
}

const rc = (val, fb = '#374151') => val || fb

// ─── Default config (exported so editor can use it) ───────────────────────────
export const defaultMobileCardStyle = {
  card: {
    bg: '#ffffff', radius: 10, borderWidth: 0, borderColor: '#e5e7eb',
    shadow: '0 2px 12px rgba(0,0,0,0.08)',
    imageWidth: 130, imageHeight: 90, contentPadding: 10,
  },
  fields: [
    { id: 'name',     label: 'Name',     enabled: true,  icon: 'none',     align: 'left', fontSize: 0.875, fontWeight: '700', color: '#111827', lineClamp: 2 },
    { id: 'price',    label: 'Price',    enabled: true,  icon: 'none',     align: 'left', fontSize: 0.875, fontWeight: '700', color: 'var(--color-price)' },
    { id: 'location', label: 'Location', enabled: true,  icon: 'location', align: 'left', fontSize: 0.75,  fontWeight: '400', color: '#6b7280' },
    { id: 'specs',    label: 'Specs',    enabled: true,  icon: 'none',     align: 'left', fontSize: 0.75,  fontWeight: '500', color: '#374151', isSpecs: true, showIcons: true, showLand: false },
    { id: 'transit',  label: 'Transit',  enabled: false, isTransit: true,  fontSize: 0.65, fontWeight: '600', variant: 'filled', showIcon: true, radius: 20 },
    { id: 'project',  label: 'Project',  enabled: false, icon: 'building', align: 'left', fontSize: 0.75,  fontWeight: '400', color: '#6b7280' },
    { id: 'label',    label: 'Sale/Rent label', enabled: false, icon: 'none', align: 'left', fontSize: 0.65, fontWeight: '700', color: '#fff', bg: '#2563eb' },
  ],
  badges: [],
}

const defaultFields = defaultMobileCardStyle.fields

// ─── SpecItem ─────────────────────────────────────────────────────────────────
function SpecItem({ iconKey, val, label, color, size, fw, showIcon }) {
  if (!val && val !== 0) return null
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }}>
      {showIcon !== false && <span style={{ color, opacity: 0.7, display: 'flex', flexShrink: 0 }}>{icons[iconKey]}</span>}
      <span style={{ fontSize: `${size}rem`, color, fontWeight: fw }}>{val}</span>
      {label && <span style={{ fontSize: `${size * 0.85}rem`, color, opacity: 0.6 }}>{label}</span>}
    </span>
  )
}

// ─── TransitBadges ────────────────────────────────────────────────────────────
function TransitBadges({ field, property }) {
  const lines = property?.publicTransport
  if (!lines?.length) return null
  const variant  = field.variant  ?? 'filled'
  const showIcon = field.showIcon ?? true
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
      {lines.map((t, i) => {
        const abbr  = t.type?.toUpperCase() ?? ''
        const label = `${abbr}${t.stationName ? ` · ${t.stationName}` : ''}`
        const color = t.colorCode ?? '#374151'
        const textColor = t.textColor ?? '#fff'
        let bg, tc, border
        if (variant === 'filled')        { bg = color; tc = textColor; border = 'none' }
        else if (variant === 'outlined') { bg = 'transparent'; tc = color; border = `1.5px solid ${color}` }
        else                             { bg = `${color}18`; tc = color; border = `1px solid ${color}30` }
        return (
          <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: 3, background: bg, color: tc, border, fontSize: `${field.fontSize ?? 0.65}rem`, fontWeight: field.fontWeight ?? '600', padding: '2px 5px', borderRadius: field.radius ?? 20, lineHeight: 1.4 }}>
            {showIcon && <span style={{ display: 'flex', flexShrink: 0 }}>{icons.transit}</span>}
            {label}
          </span>
        )
      })}
    </div>
  )
}

// ─── Main Component ───────────────────────────────────────────────────────────
function MobileMapPropertyCard({ property, cardStyle, lang = 'en', dictionary = {} }) {
  const cs     = cardStyle ?? defaultMobileCardStyle
  const card   = cs.card   ?? defaultMobileCardStyle.card
  const fields = cs.fields ?? defaultMobileCardStyle.fields
  const badges = cs.badges ?? []

  const imageW  = card.imageWidth  ?? 130
  const imageH  = card.imageHeight ?? 90
  const radius  = card.radius      ?? 10
  const bg      = card.bg          ?? '#ffffff'
  const border  = card.borderWidth > 0 ? `${card.borderWidth}px solid ${card.borderColor ?? '#e5e7eb'}` : 'none'
  const shadow  = card.shadow      ?? '0 2px 12px rgba(0,0,0,0.08)'
  const padding = card.contentPadding ?? 10

  const activeFields = fields.filter(f => f.enabled === true)
  const activeBadges = badges.filter(b => b.enabled === true)

  const location = property?.district || property?.area || property?.location || ''
  const project  = property?.project  || property?.projectName || ''

  return (
    <LinkComponent href={'/properties/' + property?.slug} style={{ textDecoration: 'none', display: 'block' }}>
      <div style={{
        display: 'flex', flexDirection: 'row', alignItems: 'stretch',
        background: bg, borderRadius: radius, border, boxShadow: shadow,
        overflow: 'hidden', width: '100%',
      }}>

        {/* ── Image ── */}
        <div style={{ position: 'relative', width: imageW, minWidth: imageW, height: imageH, flexShrink: 0, borderRadius: card.imageRadius ?? 0, overflow: 'hidden' }}>
          {property?.cover ? (
            <Image
              src={property.cover}
              alt={property?.slug ?? ''}
              fill
              sizes={`${imageW}px`}
              style={{ objectFit: 'cover' }}
              placeholder={property?.blur ? 'blur' : 'empty'}
              blurDataURL={property?.blur}
            />
          ) : (
            <div style={{ width: '100%', height: '100%', background: '#f3f4f6' }} />
          )}

          {/* Promotion badge on image */}
          {property?.isPromotion && property?.promotionTitle && (
            <div style={{ position: 'absolute', top: 6, left: 0, background: 'var(--thirdcolor, #ef4444)', color: '#fff', fontSize: '0.65rem', fontWeight: 700, padding: '2px 7px', borderRadius: '0 4px 4px 0', zIndex: 2 }}>
              {property.promotionTitle}
            </div>
          )}

          {/* Badges on image — respect variant */}
          {activeBadges.filter(b => b.showOnImage !== false).map(b => {
            const variant = b.variant ?? 'filled'
            let bg, color, border
            if (variant === 'filled')        { bg = `${b.color}dd`; color = '#fff'; border = 'none' }
            else if (variant === 'outlined') { bg = 'transparent'; color = b.color; border = `1.5px solid ${b.color}` }
            else                             { bg = `${b.color}20`; color = b.color; border = `1px solid ${b.color}35` }
            return (
              <div key={b.id} style={{ position: 'absolute', bottom: 5, left: 5, zIndex: 2 }}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, background: bg, color, border, fontSize: `${b.fontSize ?? 0.6}rem`, fontWeight: b.fontWeight ?? '600', padding: '2px 6px', borderRadius: b.radius ?? 20, lineHeight: 1.4 }}>
                  {icons[b.icon]}{b.label}
                </span>
              </div>
            )
          })}
        </div>

        {/* ── Content ── */}
        <div style={{ flex: 1, padding, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 2, minWidth: 0 }}>
          {activeFields.map((field) => {
            // ── Label ──
            if (field.id === 'label') {
              const label = property?.saleType === 'rent'
                ? (dictionary?.rent ?? 'For Rent')
                : (dictionary?.sale ?? 'For Sale')
              return (
                <div key="label" style={{ marginBottom: 3 }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, background: field.bg ?? '#2563eb', color: field.color ?? '#fff', fontSize: `${field.fontSize ?? 0.65}rem`, fontWeight: field.fontWeight ?? '700', padding: '1px 6px', borderRadius: 4, lineHeight: 1.5 }}>
                    {field.icon && field.icon !== 'none' && icons[field.icon]}
                    {label}
                  </span>
                </div>
              )
            }

            // ── Name ──
            if (field.id === 'name') {
              const lc = field.lineClamp ?? 2
              return (
                <div key="name" style={{ marginBottom: 2, textAlign: field.align ?? 'left' }}>
                  <span style={{
                    display: '-webkit-box', WebkitLineClamp: lc, WebkitBoxOrient: 'vertical',
                    overflow: 'hidden', fontSize: `${field.fontSize ?? 0.875}rem`,
                    fontWeight: field.fontWeight ?? '700', color: rc(field.color, '#111827'),
                    lineHeight: 1.3,
                  }}>
                    {property?.name ?? ''}
                  </span>
                </div>
              )
            }

            // ── Price ──
            if (field.id === 'price') {
              const hasSale = property?.salePrice !== undefined
              const hasRent = property?.rentPrice !== undefined
              if (!hasSale && !hasRent) return null
              return (
                <div key="price" style={{ textAlign: field.align ?? 'left' }}>
                  {hasSale && (
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: `${field.fontSize ?? 0.875}rem`, fontWeight: field.fontWeight ?? '700', color: rc(field.color, '#2563eb') }}>
                      {field.icon && field.icon !== 'none' && <span style={{ opacity: 0.7 }}>{icons[field.icon]}</span>}
                      <CurrencySymbol lang={lang} />{property.salePrice}
                    </div>
                  )}
                  {hasRent && (
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: `${field.fontSize ?? 0.875}rem`, fontWeight: field.fontWeight ?? '700', color: rc(field.color, '#2563eb') }}>
                      {field.icon && field.icon !== 'none' && <span style={{ opacity: 0.7 }}>{icons[field.icon]}</span>}
                      <CurrencySymbol lang={lang} />{property.rentPrice}/{dictionary?.month ?? 'mo'}
                    </div>
                  )}
                </div>
              )
            }

            // ── Project ──
            if (field.id === 'project') {
              if (!project) return null
              return (
                <div key="project" style={{ textAlign: field.align ?? 'left' }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: `${field.fontSize ?? 0.75}rem`, fontWeight: field.fontWeight ?? '400', color: rc(field.color, '#6b7280') }}>
                    {field.icon && field.icon !== 'none' && <span style={{ opacity: 0.7 }}>{icons[field.icon]}</span>}
                    {project}
                  </span>
                </div>
              )
            }

            // ── Location ──
            if (field.id === 'location') {
              if (!location) return null
              return (
                <div key="location" style={{ textAlign: field.align ?? 'left' }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: `${field.fontSize ?? 0.75}rem`, fontWeight: field.fontWeight ?? '400', color: rc(field.color, '#6b7280') }}>
                    {field.icon && field.icon !== 'none' && <span style={{ opacity: 0.7 }}>{icons[field.icon]}</span>}
                    {location}
                  </span>
                </div>
              )
            }

            // ── Specs ──
            if (field.isSpecs) {
              const color     = rc(field.color, '#374151')
              const size      = field.fontSize  ?? 0.75
              const fw        = field.fontWeight ?? '500'
              const showIcons = field.showIcons  ?? true
              const cat       = property?.category?.toLowerCase() ?? ''
              const isLand    = cat === 'land'
              const items = [
                !isLand && (cat === 'condo' || cat === 'house') && { key: 'bed',  val: property?.bedrooms,   label: '' },
                !isLand && (cat === 'condo' || cat === 'house') && { key: 'bath', val: property?.bathrooms,  label: '' },
                !isLand && { key: 'area', val: property?.livingArea ? `${property.livingArea} ${dictionary?.sqm ?? 'm²'}` : null, label: '' },
                field.showLand !== false && property?.landArea && { key: 'land', val: `${property.landArea} ${dictionary?.sqm ?? 'm²'}`, label: '' },
              ].filter(Boolean)
              if (!items.length) return null
              return (
                <div key="specs" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginTop: 2 }}>
                  {items.map((it, i) => (
                    <span key={it.key} style={{ display: 'inline-flex', alignItems: 'center' }}>
                      {i > 0 && <span style={{ color: '#e5e7eb', marginRight: 8 }}>|</span>}
                      <SpecItem iconKey={it.key} val={it.val} label={it.label} color={color} size={size} fw={fw} showIcon={showIcons} />
                    </span>
                  ))}
                </div>
              )
            }

            // ── Transit ──
            if (field.isTransit) return <TransitBadges key="transit" field={field} property={property} />

            // ── Divider ──
            if (field.isDivider) return (
              <hr key={`div-${field.id}`} style={{ border: 'none', borderTop: `${field.thickness ?? 1}px ${field.style ?? 'solid'} ${rc(field.color, '#e5e7eb')}`, margin: `${field.marginTop ?? 3}px 0 ${field.marginBottom ?? 3}px` }} />
            )

            // ── Price/sqm ──
            if (field.id === 'sqm') {
              const sqm = property?.pricePerSqm ?? (property?.salePrice && property?.livingArea ? Math.round(parseFloat(String(property.salePrice).replace(/[^0-9.]/g, '')) / parseFloat(property.livingArea)) : null)
              if (!sqm) return null
              return (
                <div key="sqm" style={{ textAlign: field.align ?? 'left' }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: `${field.fontSize ?? 0.7}rem`, fontWeight: field.fontWeight ?? '400', color: rc(field.color, '#9ca3af') }}>
                    {field.icon && field.icon !== 'none' && <span style={{ opacity: 0.7 }}>{icons[field.icon]}</span>}
                    <CurrencySymbol lang={lang} />{sqm} / m²
                  </span>
                </div>
              )
            }

            // ── Ref ──
            if (field.isRef) {
              const val = property?.ref || property?.referenceId || property?.slug || ''
              if (!val) return null
              const displayType = field.displayType ?? 'text'
              const color = field.badgeColor ?? field.color ?? '#6b7280'
              if (displayType === 'badge') {
                const variant = field.variant ?? 'outlined'
                let bg, tc, border
                if (variant === 'filled')        { bg = color; tc = '#fff'; border = 'none' }
                else if (variant === 'outlined') { bg = 'transparent'; tc = color; border = `1.5px solid ${color}` }
                else                             { bg = `${color}20`; tc = color; border = `1px solid ${color}35` }
                return (
                  <div key="ref" style={{ textAlign: field.align ?? 'left' }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', background: bg, color: tc, border, fontSize: `${field.fontSize ?? 0.7}rem`, fontWeight: field.fontWeight ?? '500', padding: '2px 8px', borderRadius: field.radius ?? 4, lineHeight: 1.4 }}>{val}</span>
                  </div>
                )
              }
              return (
                <div key="ref" style={{ textAlign: field.align ?? 'left' }}>
                  <span style={{ fontSize: `${field.fontSize ?? 0.7}rem`, fontWeight: field.fontWeight ?? '500', color: rc(field.color, '#6b7280') }}>{val}</span>
                </div>
              )
            }

            return null
          })}

          {/* Badges in content */}
          {activeBadges.filter(b => b.showOnImage === false).map(b => {
            const variant = b.variant ?? 'filled'
            let bg, color, border
            if (variant === 'filled')        { bg = b.color; color = '#fff'; border = 'none' }
            else if (variant === 'outlined') { bg = 'transparent'; color = b.color; border = `1.5px solid ${b.color}` }
            else                             { bg = `${b.color}20`; color = b.color; border = `1px solid ${b.color}35` }
            return (
              <span key={b.id} style={{ display: 'inline-flex', alignItems: 'center', gap: 3, background: bg, color, border, fontSize: `${b.fontSize ?? 0.65}rem`, fontWeight: b.fontWeight ?? '600', padding: '2px 7px', borderRadius: b.radius ?? 20, lineHeight: 1.4, marginTop: 3 }}>
                {icons[b.icon]}{b.label}
              </span>
            )
          })}
        </div>
      </div>
    </LinkComponent>
  )
}

export default MobileMapPropertyCard